import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useProgress } from "context/ProgressProvider";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppPrimaryButton } from "shared/components/AppComponents";
import { AuthActions } from "state/auth/Action";

const DialogIdle = ({ idleOpen, setIdleOpen }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const authInfo = useSelector((state: any) => state.authState);
  const { isBroker } = useProgress();

  const [shouldShowDialog, setShouldShowDialog] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    const isSblApplyRoute = location.pathname.startsWith("/sbl");

    const resetStorage = new Promise((resolve, reject) => {
      dispatch(AuthActions.resetStore({}));
      resolve(true);
    });

    resetStorage.then(() => {
      if (isBroker) {
        navigate("/broker");
      } else {
        if (isSblApplyRoute) {
          navigate("/sbl");
        } else {
          navigate("/rnd");
        }
      }
    });
  };

  useEffect(() => {
    if (authInfo.isUserLoggedIn && idleOpen === true) {
      setShouldShowDialog(true);
      handleLogout();
    }
  }, [idleOpen]);

  useEffect(() => {
    if (authInfo.isUserLoggedIn) {
      setShouldShowDialog(false);
      setIdleOpen(false);
    }
  }, [authInfo.isUserLoggedIn]);

  // UI Elements
  return (
    <>
      <Dialog
        open={shouldShowDialog && !authInfo.isUserLoggedIn}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Inactivity detected</Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h3" fontWeight={400} mb={3}>
            You’ve been inactive for 1 hour, please log in again.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ gap: "12px" }}>
          <AppPrimaryButton
            title="Log in"
            className="btn-small"
            onClick={() => {
              setShouldShowDialog(false);
              setIdleOpen(false);
            }}
            fullWidth
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DialogIdle;
